import { Typography } from '@/components/atoms/Typography';
import { DirhamIcon } from '@/components/atoms/icons/DirhamIcon';
import { useUIColors } from '@/core/hooks';
import React from 'react';
import { StyleSheet, View } from 'react-native';

export interface ChequeItemProps {
    propertyName: string;
    chequeCount: string;
    amount: number;
}

export const ChequeItem = React.memo<ChequeItemProps>(function ChequeItem({
    propertyName,
    chequeCount,
    amount,
}) {
    const colors = useUIColors();

    return (
        <View style={[styles.container, { borderColor: colors.outlineInactive }]}>
            <View style={styles.leftSection}>
                <Typography variant="footnote" color="primary" style={styles.propertyName}>
                    {propertyName}
                </Typography>
                <Typography variant="caption" color="tertiary" style={styles.chequeCount}>
                    {chequeCount}
                </Typography>
            </View>
            <View style={styles.rightSection}>
                <View style={[styles.amountContainer, { direction: 'ltr' }]}>
                    <DirhamIcon size={12} color={colors.fontPrimary} />
                    <Typography variant="subhead" color="primary" style={styles.amount}>
                        {amount.toLocaleString()}
                    </Typography>
                </View>
            </View>
        </View>
    );
});

const styles = StyleSheet.create({
    container: {
        borderWidth: 1,
        borderRadius: 8,
        flexDirection: 'row',
        alignItems: 'center',
        padding: 8,
        gap: 8,
        flex: 1,
        minWidth: 0,
    },
    leftSection: {
        flex: 1,
        gap: 4,
        minWidth: 0,
    },
    propertyName: {
        marginBottom: 0,
    },
    chequeCount: {
        marginBottom: 0,
    },
    rightSection: {
        alignItems: 'flex-end',
    },
    amountContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 4,
    },
    amount: {
        marginBottom: 0,
    },
});

export default ChequeItem;
